import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
} from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { SharedI18nModule } from '@bizzdesign/shared/i18n';
import { DividerModule } from 'primeng/divider';
import { TooltipModule } from 'primeng/tooltip';

@Component({
  selector: 'bd-frame-overlay-toolbar',
  standalone: true,
  imports: [ButtonModule, SharedI18nModule, DividerModule, TooltipModule],
  templateUrl: './frame-overlay-toolbar.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FrameOverlayToolbarComponent {
  onCloseSuggestion = output<void>();
  onSaveToWorkspace = output<void>();
  onUndoUserPrompt = output<void>();
  onRedoUserPrompt = output<void>();
  canSaveToWorkspace = input<boolean>(false);
  canUndoUserPrompt = input<boolean>(false);
  canRedoUserPrompt = input<boolean>(false);
}
